export enum QStatusEnum {
    NONE = 'NONE', // 活动未开始
    FIRST = 'FIRST', // 首次答题
    PROCEED = 'PROCEED', // 当日中断
    NEXT = 'NEXT', // 次日继续
    FINISH = 'FINISH', // 当日已完成
}

export enum QType {
    SINGLE = 'SINGLE', // 单选
    MULTIPLE = 'MULTIPLE', // 多选
}

export enum ProductModule {
    HOT = 'HOT',
    NORMAL = 'NORMAL',
    ECOLOGY = 'ECOLOGY',
    REFURBISH = 'REFURBISH',
    FLASH_SALE = 'FLASH_SALE',
    ACCESSORY = 'ACCESSORY',
    EXTRA_BATTERY = 'EXTRA_BATTERY',
    MEMBER = 'MEMBER',
    POPULAR = 'POPULAR',
    BUNDLE = 'BUNDLE',
    BUY_ONE_GET_ONE = 'BUY_ONE_GET_ONE',
    BUY_ONE_GET_ONE2 = 'BUY_ONE_GET_ONE2',
    PPS_SG = 'PPS_SG',
    PPS_SG2 = 'PPS_SG2',
    BEST_RECOMMEND = 'BEST_RECOMMEND',
    ECO_CREDITS = 'ECO_CREDITS',
    BEST_SELLERS = 'BEST_SELLERS',
    WEB_EXCLUSIVE = 'WEB_EXCLUSIVE',
    NEW_PRODUCT = 'NEW_PRODUCT',
}

export interface IQuestionInfo {
    answerStatus: QStatusEnum;
    campaignEndTime: string;
    campaignId: string;
    campaignName: string;
    campaignStartTime: string;
    description: string;
    questionGroupId: string;
    rewardTotalPoints: string;
    ruleDescription: string;
    subTitle: string;
}

export type IOptionItem = {
    correct?: boolean;
    optionId: string;
    optionName: string;
    optionSelect: string;
    optionUrl?: string;
};

export interface IQuestion {
    estimateRewardTotalPoints?: string;
    analysisCorrect?: string;
    analysisWrong?: string;
    answerCorrect?: boolean;
    defAnswer: string; // 前端独有属性 根据optionList生成 标准答案 空即为未作答
    userAnswer: string; // 前端独有属性 根据options生成 用户作答
    optionList: IOptionItem[];
    options?: string;
    picUrl?: string;
    questionId: string;
    questionName: string;
    questionType: QType; // 单选多选
    tag?: string;
}

export type IAnswerRow = {
    correct: boolean;
    createTime: string;
    id: string;
    questionName: string;
};

export interface IAnswerLog {
    content: IAnswerRow[];
    hasNext: boolean;
    total: number;
}

export type IAwardRow = {
    correctCount: number;
    createTime: string;
    discountId: 0;
    discountName: string;
    id: string;
    points: 0;
    prizeName: string;
    prizeType: string;
    prizeWayType: string;
};

export interface IAwardLog {
    content: IAwardRow[];
    hasNext: boolean;
    total: number;
}
// t&c 文案格式
export type IProtocolContent = {
    title: string;
    line: string[];
};
